<div class="card" *ngIf="account">
  <h1 class="card__title">{{ title }}</h1>
  <app-basic-card 
    [picture]="{ type: 0, value: account.imageCode }" 
    [type]="accounts?.length > 1 ? 'navigation' : 'none'" 
    (click)="openAccountList()"
  >
    <div class="card__data">
      <p class="card__name">{{ account?.account.product.productName }}</p>
      <p class="card__balance">${{ account?.account.balance.amount.amount }} <span>MXN</span></p>
      <p class="card__cta">{{ buildDetailAccount(account)}}</p>
    </div>
  </app-basic-card>
</div>

<div class="card" *ngIf="!account">
  <h1 class="card__title">{{ title }}</h1>
  <app-basic-card 
    [picture]="{ type: 0 }" 
    [type]="accounts?.length ? 'navigation' : 'none'" 
    (click)="openAccountList()"
  >
    <p class="card__select">
      Selecciona una cuenta
    </p>
  </app-basic-card>
</div>
